import { useState } from "react";

import { AnalyticsContainerProps } from "./Analytics.types";

import { useAdmin } from "hooks/useAdmin";

import Analytics from "./Analytics";

const AnalyticsContainer = ({
  documentDownloadLoading,
  withHeader,
  className,
  post,
  analyticsType,
  activePosition,
  showRecalculateButton,
  calculation,
  isAuthenticated,
  proCalculation,
  proCalculationCharts,
  proCalculationDocument,
  energyEfficiencyClass,
  onPositionChange,
  onDownloadPDFClick,
  onCalculatorStepChange,
  onAnalyticsTypeChange,
}: AnalyticsContainerProps) => {
  const isRootAdmin = useAdmin();

  const [tablesView, setTablesView] = useState<boolean>(false);

  const handleTablesViewChange = () => {
    setTablesView(!tablesView);
  };

  return (
    <Analytics
      documentDownloadLoading={documentDownloadLoading}
      withHeader={withHeader}
      className={className}
      tablesView={tablesView}
      post={post}
      calculation={calculation}
      isRootAdmin={isRootAdmin}
      tablesPro={calculation?.tablesPro}
      showRecalculateButton={showRecalculateButton}
      conclusionsPro={calculation?.conclusionsPro}
      proCalculationDocument={proCalculationDocument}
      isAuthenticated={isAuthenticated}
      proCalculation={proCalculation}
      proCalculationCharts={proCalculationCharts}
      energyEfficiencyClass={energyEfficiencyClass}
      activePosition={activePosition}
      analyticsType={analyticsType}
      onPositionChange={onPositionChange}
      onTablesViewChange={handleTablesViewChange}
      onCalculatorStepChange={onCalculatorStepChange}
      onAnalyticsTypeChange={onAnalyticsTypeChange}
      onDownloadPDFClick={onDownloadPDFClick}
    />
  );
};

export default AnalyticsContainer;
